import React, {FC, useMemo} from "react";
import {useApi} from "../api/APIContext";
import {useParams} from "react-router";
import {TaskTypeDetailsCard} from "../templates/TaskTypeDetailsCard";
import {TaskTypeTemplatesEditor} from "../templates/TaskTypeTemplatesEditor";

export const TaskTypeDetails: FC = () => {
  let { taskType } = useParams();
  const {quantityTypes} = useApi()

  const quantityType = useMemo(() => quantityTypes.find(q => q.id === taskType), [taskType, quantityTypes])

  return (
    <main className={"flex-1 overflow-y-scroll max-h-[calc(100vh-4rem)]"}>
      <div className={"mx-6 my-8"}>
        <div className={"max-w-(--breakpoint-lg) mx-auto"}>
          <div className={"flex justify-between items-center h-12 mb-4"}>
            <h1 className={"flex items-center text-2xl font-bold"}>{quantityType?.name ?? '...'}</h1>
          </div>
          {quantityType && <TaskTypeDetailsCard taskType={quantityType} />}
          {quantityType && <TaskTypeTemplatesEditor taskType={quantityType} />}
        </div>
      </div>
    </main>
  );
}
